import { useEffect, useState, useRef, Fragment } from "react";
import OtmDetalle from "./OtmDetalle";

const OtmTimelineItem = ({ otm, setSelectedOtm, selectedOtm }) => {
    const [visible, setVisible] = useState(false);
    const itemRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        // solo actualizar si no hay selección manual activa
                        if (!selectedOtm) {
                            setSelectedOtm(otm.otm);
                        }
                    }
                });
            },
            { threshold: 0.15 }
        );

        if (itemRef.current) {
            observer.observe(itemRef.current);
        }

        return () => observer.disconnect();
    }, [otm, selectedOtm, setSelectedOtm]);

    return (
        <Fragment key={`otm-${otm.otm}`}>
            <div className="time-label">
                <span className={`bg-${otm.estadoCss}`}>
                    {otm.fechaFin || otm.fechaIni}
                </span>
            </div>

            {/* id unificado */}
            <div 
                id={`otm-${otm.otm}`} 
                className={`${selectedOtm === otm.otm ? "pt-2 pb-2 table-warning" : ""}`}
                onClick={() => setSelectedOtm(otm.otm)}
            >
                <i className={`fas fa-check bg-${otm.estadoCss}`}></i>

                <div
                    ref={itemRef}
                    className={`timeline-item bg-white fade ${visible ? "show" : ""}`}
                    style={{ transition: "opacity 0.3s ease-in" }}
                >
                    <div className="timeline-header">
                        <div className="float-right text-right">
                            <span className="badge badge-info mr-1">OTM {otm.estadoOtm}</span>
                            <br />
                            <span className={`mr-1 badge badge-${otm.estadoCss}`}>
                                {otm.estadoFin}
                            </span>
                        </div>
                        <span className="text-bold text-primary h5">OTM # {otm.otm}</span>
                        <div><span className="text-info">{otm.tipoManto}</span></div>
                    </div>

                    {otm.estadoOtm === "Anulada" ? (
                        <div className="alert alert-light text-center m-2">
                            <i className="fas fa-ban mr-2"></i> OTM anulada
                            {otm.observacion && (
                                <div className="p-1 m-0">
                                    <pre className="p-1 mb-0">{otm.observacion}</pre>
                                </div>
                            )}
                        </div>
                    ) : (
                        <OtmDetalle otm={otm} />
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default OtmTimelineItem;
